import { NS } from "../common/classes";

export const BUTTON = `${NS}-button`;
export const BUTTON_TEXT = `${NS}-button-text`;
